var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.48523 7.63811L7.63673 8.4866L9.33372 10.1836L7.63673 11.8806L8.48523 12.7291L10.1822 11.0321L11.8792 12.7291L12.7277 11.8806L11.0307 10.1836L12.7277 8.4866L11.8792 7.63811L10.1822 9.3351L8.48523 7.63811ZM5.93974 5.94112C3.5979 8.28296 3.5979 12.0842 5.93974 14.4261C8.28159 16.7679 12.0829 16.7679 14.4247 14.4261C16.7665 12.0842 16.7665 8.28296 14.4247 5.94112C12.0829 3.59927 8.28159 3.59927 5.93974 5.94112ZM13.5762 13.5776C11.7053 15.4485 8.65917 15.4485 6.78824 13.5776C4.91731 11.7066 4.91731 8.66054 6.78824 6.78961C8.65917 4.91868 11.7053 4.91868 13.5762 6.78961C15.4471 8.66054 15.4471 11.7066 13.5762 13.5776Z",
    fill: "#C81616"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.ae6549f3b67eea62e4e7a7bcc0fe83ec.svg";
export { ForwardRef as ReactComponent };